import { isFeatureEnabled } from 'owa-feature-flags';
import { getStore as getSharedFavoritesStore } from '../store/store';
import type { FavoritePersonaNode, FavoritePersonaData } from 'owa-favorites-types';

export default function getFavoritePersona(
    favoriteId: string
): FavoritePersonaData | FavoritePersonaNode | null {
    const favoritesStore = getSharedFavoritesStore();
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (12,5): Type 'FavoritePersonaNode | FavoritePersonaData | undefined' is not assignable to type 'FavoritePersonaNode | FavoritePersonaData | null'.
    // @ts-expect-error
    return isFeatureEnabled('tri-favorites-roaming')
        ? (favoritesStore.outlookFavorites.get(favoriteId) as FavoritePersonaData)
        : favoritesStore.favoritesPersonaNodes.get(favoriteId);
}
